export function providerKey(p) {
  return String(p || "").toLowerCase().replace(/\s+/g, "");
}

export function isProviderSelected(provider, models, selectedId) {
  return models.some((m) => providerKey(m.provider) === providerKey(provider) && m.value === selectedId);
}
